import { useState } from "react";
import { afrosoundsimgs } from "../data/galleryimgdata";

const Afrosounds = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(afrosoundsimgs[index].image);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const prevImage = () => {
    const newIndex =
      (currentIndex - 1 + afrosoundsimgs.length) % afrosoundsimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(afrosoundsimgs[newIndex].image);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % afrosoundsimgs.length;
    setCurrentIndex(newIndex);
    setSelectedImage(afrosoundsimgs[newIndex].image);
  };

  return (
    <>
      <h1>Afrosounds</h1>
      <div className="gallery-images-container">
        {afrosoundsimgs.map((afrosounds, index) => (
          <img
            loading="lazy"
            alt="afrosounds"
            src={afrosounds.image}
            key={afrosounds.id}
            onClick={() => openImage(index)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>

      {selectedImage && (
        <div className="modal">
          <span className="close" onClick={closeImage}>
            &times;
          </span>
          <button className="prev" onClick={prevImage}>
            &#10094;
          </button>
          <img src={selectedImage} alt="Selected" className="modal-content" />
          <button className="next" onClick={nextImage}>
            &#10095;
          </button>
        </div>
      )}
    </>
  );
};

export default Afrosounds;
